import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { ApiService, EstimateService, FileService, Invoice, InvoiceModel } from '@mmx/shared'
import { finalize, Subject, takeUntil } from 'rxjs'

@Component({
  selector: 'mmx-estimate-print-invoice-button',
  templateUrl: './estimate-print-invoice-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EstimatePrintInvoiceButtonComponent implements OnChanges, OnDestroy {
  @Input()
  public invoices: InvoiceModel[] = []

  public eligibleInvoices: InvoiceModel[] = []

  private onDestroy$ = new Subject<void>()

  constructor(
    public readonly estimateService: EstimateService,
    private readonly apiService: ApiService,
    private readonly fileService: FileService,
    private readonly snackBar: MatSnackBar,
  ) {}

  public ngOnChanges() {
    this.eligibleInvoices = (this.invoices || []).filter((invoice) => invoice.status !== Invoice.STATUS.VOID)
  }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  public onPrintClick() {
    if (this.eligibleInvoices.length === 1) {
      this.printInvoice(this.eligibleInvoices[0])
    }
  }

  public printInvoice(invoice: InvoiceModel) {
    if (!invoice?.id) {
      return
    }

    this.estimateService.estimateLoading$.next(true)
    this.apiService.generateInvoicePDF(invoice.id)
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => this.estimateService.estimateLoading$.next(false)),
      )
      .subscribe({
        next: (resp) => this.fileService.saveAs(resp.data),
        error: () => {
          this.snackBar.open(
            'An error occurred while trying to download the invoice document.',
            undefined,
            { duration: 3000 },
          )
        },
      })
  }
}
